import { render, staticRenderFns } from "./loading-button.vue?vue&type=template&id=71484f29&"
import script from "./loading-button.vue?vue&type=script&lang=js&"
export * from "./loading-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports